export const phoneNumberReg = {
  requiredMessage: '휴대폰번호를 입력해주세요.',
  patternMessage: '올바른 휴대폰번호를 입력해주세요.',
  minLength: 13,
  regExp: /^01([016789])-?([0-9]{3,4})-?([0-9]{4})$/
};

export const birthdayReg = {
  requiredMessage: '생년월일을 입력해주세요.',
  patternMessage: '8자리 숫자로 입력해주세요. 예) 19900101',
  regExp: /^(19[0-9][0-9]|20\d{2})\.(0[0-9]|1[0-2])\.(0[1-9]|[1-2][0-9]|3[0-1])$/
};

export const nameReg = {
  patternMessage: '이름을 올바르게 입력해주세요.',
  requiredMessage: '이름을 입력해주세요.',
  regExp: /^[a-zA-Z0-9가-힣\s]{2,50}$/
};
